import React from 'react';

export const TimerSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill="#000" fillRule="nonzero">
      <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14.4A6.4 6.4 0 1 1 8 1.6a6.4 6.4 0 0 1 0 12.8z" />
      <path d="M8 3.2H6.8v5.016c0 .543.44.984.984.984H12V8H8V3.2z" />
    </g>
  </svg>
);

export const Bookmark = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="32"
    viewBox="0 0 24 32"
  >
    <path
      fill="none"
      fillRule="nonzero"
      stroke="#1D2225"
      strokeWidth="2.4"
      d="M1.2 29.91l10.8-6.3 10.8 6.3V3A1.8 1.8 0 0 0 21 1.2H3A1.8 1.8 0 0 0 1.2 3v26.91z"
    />
  </svg>
);

export const Expand = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill="#1D2225"
      fillRule="nonzero"
      d="M0 10.571V1.714C0 .764.764 0 1.714 0h8.857a.86.86 0 0 1 .858.857v.572a.86.86 0 0 1-.858.857H2.286v8.285a.86.86 0 0 1-.857.858H.857A.86.86 0 0 1 0 10.57zM21.429 0h8.857C31.236 0 32 .764 32 1.714v8.857a.86.86 0 0 1-.857.858h-.572a.86.86 0 0 1-.857-.858V2.286H21.43a.86.86 0 0 1-.858-.857V.857A.86.86 0 0 1 21.43 0zM32 21.429v8.857A1.71 1.71 0 0 1 30.286 32h-8.857a.86.86 0 0 1-.858-.857v-.572a.86.86 0 0 1 .858-.857h8.285V21.43a.86.86 0 0 1 .857-.858h.572a.86.86 0 0 1 .857.858zM10.571 32H1.714A1.71 1.71 0 0 1 0 30.286v-8.857a.86.86 0 0 1 .857-.858h.572a.86.86 0 0 1 .857.858v8.285h8.285a.86.86 0 0 1 .858.857v.572a.86.86 0 0 1-.858.857z"
    />
  </svg>
);

export const CloseSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M9.82 8l5.982-5.982a.552.552 0 0 0 0-.781L14.763.197a.552.552 0 0 0-.781 0L8 6.18 2.018.198a.552.552 0 0 0-.781 0L.197 1.237a.552.552 0 0 0 0 .781L6.18 8 .198 13.982a.552.552 0 0 0 0 .781l1.039 1.04a.552.552 0 0 0 .781 0L8 9.82l5.982 5.981a.552.552 0 0 0 .781 0l1.04-1.039a.552.552 0 0 0 0-.781L9.82 8z"
    />
  </svg>
);

export const SmallCloseSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
  >
    <g stroke="none" strokeWidth="1" fill="#888888" fillRule="evenodd">
      <polygon points="9.29923077 1.68384615 8.31615385 0.700769231 5 4.02384615 1.68384615 0.700769231 0.700769231 1.68384615 4.02384615 5 0.700769231 8.31615385 1.68384615 9.29923077 5 5.97615385 8.31615385 9.29923077 9.29923077 8.31615385 5.97615385 5"></polygon>
    </g>
  </svg>
);

export const CalculatorAllowedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="17"
    viewBox="0 0 14 17"
  >
    <path
      fill="#E57200"
      fillRule="evenodd"
      d="M0 0h14v17H0V0zm2 2v3h10V2H2zm0 5v2h2V7H2zm8 0v2h2V7h-2zM6 7v2h2V7H6zm-4 3v2h2v-2H2zm8 0v2h2v-2h-2zm-4 0v2h2v-2H6zm-4 3v2h2v-2H2zm8 0v2h2v-2h-2zm-4 0v2h2v-2H6z"
    />
  </svg>
);

export const ZoomIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="31.718"
    height="32"
    viewBox="0 0 31.718 32"
  >
    <path
      id="close"
      d="M39.365,37.661l-8.017-8.417A13.227,13.227,0,0,0,20.927,8a13.027,13.027,0,1,0,0,26.054,12.426,12.426,0,0,0,8.017-2.605l8.017,8.017a1.4,1.4,0,0,0,2.2,0,1.335,1.335,0,0,0,0-2ZM21.127,31.248a10.021,10.021,0,1,1,7.157-3.006,10.021,10.021,0,0,1-7.157,3.006Zm5.612-10.021a1.505,1.505,0,0,1-1.4,1.4H22.53v2.806a1.549,1.549,0,0,1-1.4,1.6,1.4,1.4,0,0,1-1.4-1.6V22.63H16.718a1.4,1.4,0,0,1-1.4-1.6,1.371,1.371,0,0,1,1.4-1.4h3.006V16.818a1.415,1.415,0,1,1,2.806,0v2.806h2.806a1.371,1.371,0,0,1,1.4,1.4Z"
      transform="translate(-7.9 -8)"
      fill="#1e1e1e"
    />
  </svg>
);

export const smallZoomIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="4 4 27 26"
    width="20"
    height="20"
  >
    <path d="M23.6 22.8l-4-4.2A6.6 6.6 0 0 0 14.4 8a6.5 6.5 0 1 0 0 13c1.5 0 2.9-.4 4-1.3l4 4a.7.7 0 0 0 1.1 0c.3-.2.3-.7 0-1zm-9.1-3.2a5 5 0 0 1-5-5 5 5 0 0 1 5-5.1 5 5 0 0 1 5 5 5 5 0 0 1-5 5.1zm2.8-5c0 .3-.3.7-.7.7h-1.4v1.4c0 .4-.3.8-.7.8a.7.7 0 0 1-.7-.8v-1.4h-1.5a.7.7 0 0 1-.7-.8c0-.4.3-.7.7-.7h1.5v-1.4c0-.4.3-.8.7-.8.4 0 .7.4.7.8v1.4h1.4c.4 0 .7.3.7.7z" />
  </svg>
);

export const Save = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
  >
    <path
      fill="#1E1E1E"
      fillRule="nonzero"
      d="M20.4351295 6.9351295l-3.370259-3.370259C16.7031953 3.2031926 16.2126576 3 15.7011696 3H4.92857143C3.8634375 3 3 3.8634375 3 4.9285714v14.1428572C3 20.1365625 3.8634375 21 4.92857143 21H19.0714286C20.1365625 21 21 20.1365625 21 19.0714286V8.2988304c0-.511488-.2031926-1.0020257-.5648705-1.3637009zm-5.8637009-2.6494152v3.8571428H6.85714286V4.2857143h7.71428574zm5.1428596 14.7857143c0 .3544553-.2884043.6428571-.6428596.6428571H4.92857143c-.35445536 0-.64285714-.2884018-.64285714-.6428571V4.9285714c0-.3544553.28840178-.6428571.64285714-.6428571h.64285714v4.1785714c0 .532567.43171875.9642857.96428572.9642857h8.35714281c.532567 0 .9642858-.4317187.9642858-.9642857V4.305442c.1130446.0278986.2163058.0861845.2986071.1685491L19.5260089 7.84425c.1209534.1202991.1887501.2839891.1882793.4545804v10.7725982zM12 11.0357143c-1.9495848 0-3.53571429 1.5861295-3.53571429 3.5357143S10.0504152 18.1071429 12 18.1071429s3.5357143-1.5861295 3.5357143-3.5357143S13.9495848 11.0357143 12 11.0357143zm0 5.7857143c-1.2406741 0-2.25-1.0093259-2.25-2.25s1.0093259-2.25 2.25-2.25 2.25 1.0093259 2.25 2.25-1.0093259 2.25-2.25 2.25z"
    />
  </svg>
);

export const Grabber = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    width="19px"
    height="4px"
    viewBox="0 0 19 4"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-543.000000, -166.000000)" fill="#888888">
        <g transform="translate(213.000000, 153.000000)">
          <g transform="translate(330.000000, 13.000000)">
            <circle cx="2" cy="2" r="2" />
            <circle cx="7" cy="2" r="2" />
            <circle cx="12" cy="2" r="2" />
            <circle cx="17" cy="2" r="2" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
